// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.VrmConfigurationList in vrmConfig/vrmConfig.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.immutableCopyOf
import com.squareup.wire.`internal`.redactElements
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import okio.ByteString

/**
 * List of VRM configurations
 */
public class VrmConfigurationList(
  vrms: List<VrmConfiguration> = emptyList(),
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<VrmConfigurationList, Nothing>(ADAPTER, unknownFields) {
  @field:WireField(
    tag = 1,
    adapter = "vreo.volt.protocol.VrmConfiguration#ADAPTER",
    label = WireField.Label.REPEATED,
    schemaIndex = 0,
  )
  public val vrms: List<VrmConfiguration> = immutableCopyOf("vrms", vrms)

  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is VrmConfigurationList) return false
    if (unknownFields != other.unknownFields) return false
    if (vrms != other.vrms) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + vrms.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    if (vrms.isNotEmpty()) result += """vrms=$vrms"""
    return result.joinToString(prefix = "VrmConfigurationList{", separator = ", ", postfix = "}")
  }

  public fun copy(vrms: List<VrmConfiguration> = this.vrms, unknownFields: ByteString = this.unknownFields): VrmConfigurationList = VrmConfigurationList(vrms, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<VrmConfigurationList> =
        object : ProtoAdapter<VrmConfigurationList>(
      FieldEncoding.LENGTH_DELIMITED, 
      VrmConfigurationList::class, 
      "type.googleapis.com/vreo.volt.protocol.VrmConfigurationList", 
      PROTO_3, 
      null, 
      "vrmConfig/vrmConfig.proto"
    ) {
      override fun encodedSize(`value`: VrmConfigurationList): Int {
        var size = value.unknownFields.size
        size += VrmConfiguration.ADAPTER.asRepeated().encodedSizeWithTag(1, value.vrms)
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: VrmConfigurationList) {
        VrmConfiguration.ADAPTER.asRepeated().encodeWithTag(writer, 1, value.vrms)
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: VrmConfigurationList) {
        writer.writeBytes(value.unknownFields)
        VrmConfiguration.ADAPTER.asRepeated().encodeWithTag(writer, 1, value.vrms)
      }

      override fun decode(reader: ProtoReader): VrmConfigurationList {
        val vrms = mutableListOf<VrmConfiguration>()
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> vrms.add(VrmConfiguration.ADAPTER.decode(reader))
            else -> reader.readUnknownField(tag)
          }
        }
        return VrmConfigurationList(
          vrms = vrms,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: VrmConfigurationList): VrmConfigurationList = value.copy(
        vrms = value.vrms.redactElements(VrmConfiguration.ADAPTER),
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
